// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26VRf","label":"styles_label__20vhd"};